'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(r, e) {
    if (null == r) return {};
    var t, o, i = _object_without_properties_loose(r, e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(r);
        for(o = 0; o < n.length; o++)t = n[o], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(r, t) && (i[t] = r[t]);
    }
    return i;
}
function _object_without_properties_loose(r, e) {
    if (null == r) return {};
    var t, o, i = {}, n = Object.keys(r);
    for(o = 0; o < n.length; o++)t = n[o], e.indexOf(t) >= 0 || (i[t] = r[t]);
    return i;
}
const Divider = renderWithRef('Divider', null, (t, o)=>{
    var { children: i } = t;
    return jsx(RenderComp, {
        root: "hr",
        classNames: [
            'swan-divider'
        ],
        forwardedRef: o,
        props: _object_without_properties(t, [
            "children"
        ]),
        children: i
    });
});

export { Divider };
